import React, { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import EventThemesBase from "../themes/themes-base";
import Sun from "../../img/san_1.png";
import FlowerSmile from "../../img/sunflowers_1000.png";

import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function EbAutOne({ebautData, themesData}) {

    return (
        <>
            <section className="py-20 relative overflow-hidden">
                <div
                    className="container relative z-30 grid md:grid-cols-2 grid-cols-1 gap-4 w-[90%] max-w-screen-lg mx-auto rounded-2xl"
                    id="ebaut">
                    <ScrollAnimation
                        animatePreScroll="true"
                        offset="1"
                        animateIn="animate__fadeInLeft relative z-30"
                        className="mb-6"
                    >
                        <div className="flex items-center">
                            <p className="copy-h2 text-[42px] mr-4">30+</p>
                            <p className="copy-h3-alt">спікерів</p>
                        </div>
                        <div className="flex items-center">
                            <p className="copy-h2 text-[42px] mr-4">4</p>
                            <p className="copy-h3-alt">панельні дискусії</p>
                        </div>
                        <div className="flex items-center mb-4">
                            <p className="copy-h2 text-[42px] mr-4">500+</p>
                            <p className="copy-h3-alt">учасників офлайн</p>
                        </div>
                        <div className="flex items-center mb-4">
                            <p className="copy-h2 text-[42px] mr-4">8000+</p>
                            <p className="copy-h3-alt">глядачів трансляції</p>
                        </div>
                    </ScrollAnimation>
                    <div>
                        <ScrollAnimation animatePreScroll="true" animateIn="animate__fadeInRight" offset="1">
                            {
                                ebautData ?
                                    <>
                                        <h2 className="text-4xl mb-4 uppercase">{ebautData.ebaut_title}</h2>
                                        <div
                                            className="mb-[30px] text-[16px] font-light text-etGray md:mb-[30px] rev-slide-up ebaut-text"
                                            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(ebautData.ebaut_text, {sanitize: true})}}/>
                                    </> : ''
                            }


                        </ScrollAnimation>
                        <ScrollAnimation animatePreScroll="true" animateIn="animate__fadeInRight" offset="1">
                            <EventThemesBase themesData={themesData}/>
                        </ScrollAnimation>

                    </div>

                </div>
                <img src={Sun} alt="Сонечко"
                     className="absolute -top-[50px] right-0 w-ful max-w-[500px] z-10 opacity-20"
                     id="sun"/>
                <img src={FlowerSmile} alt="Усміхнена квітка"
                     className="absolute -bottom-[100px] -left-[50px] z-10 w-full max-w-[800px] opacity-20"
                     id="flowersmile"/>
            </section>
        </>
    )
}

export default EbAutOne